import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.333 5.5v8.267c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436h-1.866c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216V5.5M8.25 9.167h5.5M3.667 5.5h14.666c1.013 0 1.834-.82 1.834-1.833v0c0-1.013-.821-1.834-1.834-1.834H3.667c-1.013 0-1.834.821-1.834 1.834v0c0 1.012.821 1.833 1.834 1.833Z"
    />
  </svg>
)
export default SvgComponent
